const Audit = {
    barcodeSearch: () => 'store/inventory-audit/product',
    itemCondition: (id: string) => `store/inventory-audit/product/${id}/condition`,
}
export default Audit